import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { CardContainerProps } from './cms-article-card.types';

import { Heading2, Heading3 } from '@blueprint/heading';
import { Link } from '@blueprint/link';
import { styled as zds } from '@zoopla-eng/zds-components/themes';

export const CardContainer = styled('article')<CardContainerProps>(
    ({
        heroArticle,
        theme: { borderRadius, colors, mediaQueries, spacing }
    }) => css`
        cursor: pointer;
        position: relative;

        img {
            width: 100%;
            border-radius: ${borderRadius['400']};
            object-fit: cover;
            margin-bottom: ${spacing['16px']};
            aspect-ratio: 16/9;
        }

        ${mediaQueries.medium} {
            margin: 0;
        }

        ${Link} {
            color: ${colors['grey-slate']};

            &:focus {
                display: block;
            }

            &::before {
                bottom: 0;
                content: '';
                cursor: pointer;
                left: 0;
                overflow: hidden;
                position: absolute;
                right: 0;
                top: 0;
                z-index: 1;
            }
        }
        ${Heading2},
        ${Heading3} {
            margin-bottom: ${spacing['8px']};
        }

        &.horizontal {
            ${heroArticle ? mediaQueries.medium : mediaQueries.extraLarge} {
                display: flex;
                height: 228px;

                picture {
                    width: 50%;
                    img {
                        height: 100%;
                        margin-bottom: 0;
                    }
                }

                .article-card__info {
                    display: flex;
                    flex-direction: column;
                    justify-content: left;
                    padding-left: ${spacing['24px']};
                    width: 50%;

                    ${mediaQueries.large} {
                        padding-top: ${spacing['16px']};
                    }
                }

                &.heroArticle {
                    height: auto;

                    picture {
                        img {
                            height: 200px;

                            ${mediaQueries.large} {
                                height: 270px;
                            }

                            ${mediaQueries.extraLarge} {
                                height: 320px;
                            }
                        }
                    }
                }
            }
        }
    `
);

export const ArticleSnippetText = zds('p', {
    display: '-webkit-box',
    fontGroup: 'ladle',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',

    variants: {
        lines: {
            2: {
                WebkitLineClamp: 2
            },
            3: {
                WebkitLineClamp: 3
            }
        }
    },
    defaultVariants: {
        lines: 2
    }
});
